<template>
  <div class="grid-container full">
    <div
      ref="callOutBox"
      class="grid-x callOutBox"
      :class="{white: CallOutColor === 'white', brown: CallOutColor === 'brown', grey: CallOutColor === 'grey', midgrey: CallOutColor === 'midgrey', darkgrey: CallOutColor === 'darkgrey'}">
      <div class="small-12 cell text-center">

        <div v-if="IsH1">
          <h2
            v-if="CallOutTitle !== ''"
            class="callOutTitle"
            :class="{showForMedium: CallOutTitleSmall !== '',
            whiteTitle:  CallOutColor === 'white',
            lowercase: Lowercase === true}">{{ CallOutTitle }}
          </h2>
          <h3
            v-if="CallOutTitleSmall !== ''"
            :class="{whiteTitle:  CallOutColor === 'white'}"
            class="callOutTitle show-for-small-only">{{ CallOutTitleSmall }}
          </h3>
        </div>
        <div v-else-if="!IsH1">
          <h3
            v-if="CallOutTitle !== ''"
            class="callOutTitle"
            :class="{showForMedium: CallOutTitleSmall !== '', whiteTitle:  CallOutColor === 'white'}" v-html="CallOutTitle" />
          <h3
            v-if="CallOutTitleSmall !== ''"
            :class="{whiteTitle:  CallOutColor === 'white'}"
            class="callOutTitle show-for-small-only">{{ CallOutTitleSmall }}
          </h3>
        </div>

        <p
          v-if="CallOutBody !== ''"
          :class="{whiteBody:  CallOutColor === 'white'}"
          class="callOutBody show-for-medium" v-html="CallOutBody"></p>
        <p
          v-if="CallOutBodySmall !== ''"
          :class="{whiteBody:  CallOutColor === 'white'}"
          class="callOutBody show-for-small-only" v-html="CallOutBodySmall"></p>

        <div v-if="ButtonShow" class="button-container">
          <rare-standard-button
            class="contactButton show-for-small-only"
            :tabindex="19"
            :active="'true'"
            :buttonText="ButtonText"
            :height="'40px'"
            :width="'150px'"
            :fontColor="'#ffffff'"
            :fontSize="'14px'"
            @clicked="handleButtonClick()"
          />
          <rare-standard-button
            class="contactButton show-for-medium"
            :tabindex="19"
            :active="'true'"
            :buttonText="ButtonText"
            :height="'70px'"
            :width="'220px'"
            :fontColor="'#ffffff'"
            :fontSize="'20px'"
            @clicked="handleButtonClick()"
          />

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import RareStandardButton from '@/components/atoms/RareWebButton';

export default {
  name: 'RareCallOutBox',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  props: {
    CallOutTitle: {
      type: String,
      required: false,
      default: '',
    },
    CallOutTitleSmall: {
      type: String,
      required: false,
      default: '',
    },
    CallOutBody: {
      type: String,
      required: false,
      default: '',
    },
    CallOutBodySmall: {
      type: String,
      required: false,
      default: '',
    },

    CallOutColor: {
      type: String,
      required: false,
      default: 'brown',
    },
    paddingX: {
      type: String,
      required: false,
      default: '15%',
    },
    IsH1: {
      type: Boolean,
      required: false,
      default: false,
    },
    Lowercase: {
      type: Boolean,
      required: false,
      default: false,
    },
    ButtonShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    ButtonText: {
      type: String,
      required: false,
      default: '',
    },
    ButtonLink: {
      type: String,
      required: false,
      default: '',
    },
  },
  mounted() {
    if (this.paddingX) {
      this.$refs.callOutBox.style.paddingLeft = this.paddingX;
      this.$refs.callOutBox.style.paddingRight = this.paddingX;
    }
  },
  methods: {
    handleButtonClick() {
      window.open(this.ButtonLink, '_blank').focus();
    },
  },
};

</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  a {
    color: #ffffff;
  }

  .white {
    background-color: #ffffff;
  }

  .whiteTitle {
    color: $green-highlight !important;
  }

  .whiteBody {
    color: $main-text !important;
    font-weight: bold !important;
  }

  .brown {
    background-color: $brown-background;
  }

  .grey {
    background-color: $dark-grey-background;
  }

  .midgrey {
    background-color: $mid-grey-background;
  }

  .darkgrey {
    background-color: $mid-grey-background;
  }

  .lowercase {
    text-transform: none !important;
  }

  h2.callOutTitle, h3.callOutTitle {
    color: #ffffff;
    font-weight: 800;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    text-transform: uppercase;
  }

  p.callOutBody {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  @media only screen and (max-width: 640px)  {
    .showForMedium {
      display: none;
    }

    .callOutBox {
      padding: 40px 0 40px 0;
    }

    h2.callOutTitle, h3.callOutTitle {
      font-size: 18px;
      line-height: 1.6;
      margin: 0 0 0 0;
      padding: 0 0 0 0;
    }

    p.callOutBody {
      font-size: 18px;
      line-height: 1.71;
      margin: 15px 0 0 0;
      padding: 0 0 0 0;
    }

    .button-container {
      max-width: 150px;
      margin: 22px auto 9px auto;
    }
  }

  @media only screen and (min-width: 641px) {
    .showForMedium {
      display: block;
    }

    .callOutBox {
      padding: 70px 0 70px 0;
    }

    h2.callOutTitle, h3.callOutTitle {
      font-size: 54px;
      line-height: 1.6;
      margin: 0 0 0 0;
      padding: 0 0 0 0;
    }

    h2.callOutTitle {
      font-size: 54px;
    }

    h3.callOutTitle {
      font-size: 30px;
    }

    p.callOutBody {
      font-size: 24px;
      line-height: 1.52;
      margin: 15px 0 0 0;
      padding: 0 0 0 0;
    }

    .button-container {
      display: flex;
      justify-content: center;
      margin-top: 33px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/commonSections/RareCallOutBox.vue